module.exports = __webpack_public_path__ + "img/file.65a74376.png";